import { useMemo } from 'react';
import { useI18nProvider } from "./useI18nProvider.js";
import { useStore } from "../store/useStore.js";
/**
 * Get the current locale and the ability to change it
 *
 * @example
 *
 * import { useLocaleState } from 'react-admin';
 *
 * const availableLanguages = {
 *     en: 'English',
 *     fr: 'Français',
 * }
 * const LocaleSwitcher = () => {
 *     const [locale, setLocale] = useLocaleState();
 *     return (
 *         <div>
 *             <div>Language</div>
 *             <Button disabled={locale === 'fr'} onClick={() => setLocale('fr')}>
 *                 English
 *             </Button>
 *             <Button disabled={locale === 'en'} onClick={() => setLocale('en')}>
 *                 French
 *             </Button>
 *         </div>
 *     );
 * };
 */
export var useLocaleState = function () {
    var i18nProvider = useI18nProvider();
    var defaultLocale = useMemo(function () { return i18nProvider.getLocale(); }, [i18nProvider]);
    return useStore('locale', defaultLocale);
};
//# sourceMappingURL=useLocaleState.js.map